export default {
  title: 'Rejestracja konta zawodnika grupy treningowej',
  type: 'object',
  properties: {
    email: {
      title: 'schema.account.email',
      format: 'email',
      type: 'string',
      fieldRequired: true
    },
    profileId: {
      type: 'number',
      fieldRequired: true
    },
    teamId: {
      type: 'number',
      fieldRequired: true
    }
  }
};
